/*
tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import 'ag-grid-enterprise';
import {Train}                 from '@/models/scenario/train';
import {ICellRenderer, ICellRendererParams} from "ag-grid-community";

/**
 *
 * @class TrainsRenderer
 *
 * @brief cell rendering a group of trains
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2020
 *
 */
export class TrainsRenderer implements ICellRenderer {

  /** agGrid DOM element for display */
  public gui: HTMLElement;

  /** the value being rendered */
  public value: Train[] = [];

  /** first time creation of the rendered cell. */
  public init(params: ICellRendererParams): void {

    this.gui           = document.createElement('div');
    this.gui.innerHTML = `<span style="color: grey;"></span>`;

    /* render! */

    this.refresh(params);
  }

  /** return the currently rendered DOM */
  public getGui(): HTMLElement {

    return this.gui;
  }

  /** update the rendered DOM */
  public refresh(params: ICellRendererParams): boolean {

    this.value = params?.value;

    if (!this.value) {

      this.gui.innerHTML = `<span style="color: grey;"></span>`;
      return ;
    }

    /* build the list of train names */

   let text: string = '';

   for (const train of this.value) {

     if (text.length) {

       text += ', ';
     }

     text += train._name;
   }

    /* limit the size that we show ... */

    if (text.length >= 24) {

      text = text.substring(0, 24) + '...';
    }

    /* render */

    this.gui.innerHTML = `<span style="color: grey;">${text}</span>`;

    return true;
  }

  /** destructor for rendered DOM */
  public destroy() {

  }

}
